/* Action Types */
export const THROW_ERROR = "THROW_ERROR";
export const DISMISS_ERROR = "DISMISS_ERROR";

// Admin Constants
export const FETCH_ACCESS_REQUESTS = "FETCH_ACCESS_REQUESTS";
export const FETCHED_ACCESS_REQUESTS = "FETCHED_ACCESS_REQUESTS";
export const APPROVE_REQUEST = "APPROVE_REQUEST";
export const APPROVED_REQUEST = "APPROVED_REQUEST";
export const REJECT_REQUEST = "REJECT_REQUEST";
export const REJECTED_REQUEST = "REJECTED_REQUEST";
export const UNDO_REQUEST = "UNDO_REQUEST";

// Company Search
export const UPDATE_COMPANY_SEARCH_TERM = "UPDATE_COMPANY_SEARCH_TERM";
export const SHOW_LOADING_INDICATOR = "SHOW_LOADING_INDICATOR";
export const FETCHED_COMPANY_SUGGESTIONS = "FETCHED_COMPANY_SUGGESTIONS";
export const ERROR_FETCHING_SUGGESTIONS = "ERROR_FETCHING_SUGGESTIONS";
export const SELECT_COMPANY = "SELECT_COMPANY";
export const SET_OTHER_ASSOCIATED_ACCOUNT = "SET_OTHER_ASSOCIATED_ACCOUNT";
export const NO_MATCHING_COMPANIES = "NO_MATCHING_COMPANIES";

// Form Constants
export const SUBMIT_FORM = "SUBMIT_FORM";

//Common Constants
export const IS_SAVING = "IS_SAVING";
export const DISABLE_LANGUAGE_SELECTOR = "DISABLE_LANGUAGE_SELECTOR";
export const IS_BUTTONS_VISIBLE = "IS_BUTTONS_VISIBLE";

export const SET_GEO_POL_DATA = "SET_GEO_POL_DATA";

// For Country State Mapping from API
export const SET_COUNTRY_STATE_MAPPING_DATA = "SET_COUNTRY_STATE_MAPPING_DATA";
